var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcArrowDropDown = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__a3412",
    d: "M0.417 0.167L5 4.75 9.583 0.167z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 1,
    transform: "translate(6 9)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__b34124132",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__a3412"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#1890ff",
    mask: "url(#prefix__b34124132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H45.833V45.833H0z",
    transform: "translate(-17.917 -20.917)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcArrowDropDown, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-arrow-drop-down.fa3ddafb.svg";
export { ForwardRef as ReactComponent };